module.exports = __webpack_public_path__ + "resources/img/img_voice_studio2.797016d622174c3b50ec73bc420eb8c9.png";